import { createAction, props } from '@ngrx/store';

import { RegistrationManager } from './registration.reducer';


export const updateRegistrationManager = createAction('[RegistrationManager] Update', props<{ payload: Partial<RegistrationManager> }>());
export const resetRegistrationManager = createAction('[RegistrationManager] Reset');
